import "./index.css";

export type ListOption = {
  label: string;
  value: string;
};

type Props = {
  options: ListOption[];
  onClick: (value: ListOption) => void;
};

function ListOptionInput(props: Props) {
  const { options, onClick } = props;
  return (
    <div className="form-input-container bg-white">
      <div className="flex max-h-260 flex-col overflow-auto">
        {options.map((option, index) => (
          // border-b property not working, need to explicitly set border-x-0 border-t-0
          <>
            <div
              className="cursor-pointer rounded-lg p-2.5 text-sm text-neutral-strong hover:bg-gray-50"
              onClick={() => onClick(option)}
              key={option.value}
            >
              {option.label}
            </div>
            {index < options.length - 1 && (
              <div className="my-1 border border-x-0 border-t-0 border-solid border-grey-50 last:border-b-0" />
            )}
          </>
        ))}
      </div>
    </div>
  );
}

export default ListOptionInput;
